import HttpService from '../../system/services/HttpService'

export default {
    getAppDownloadLink: (data) => {
        return HttpService.get('/dashboard/account/linkToDownloadApp', data)
    },
}
